import { render } from "./CartPage.vue?vue&type=template&id=c5c1cd32&ts=true"
import script from "./CartPage.vue?vue&type=script&lang=ts"
export * from "./CartPage.vue?vue&type=script&lang=ts"

import "./CartPage.vue?vue&type=style&index=0&id=c5c1cd32&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__